import { call, put, takeLatest } from 'redux-saga/effects';
import { message } from 'antd';

import loginAuth from '../requests/login.requests';
import LoginAction from '../actions/LoginAction';

import NavigationAction from '../actions/NavigationAction';
import { types } from '../types';
// import history from '../../commons/history';

export function* userLoginAuth(action) {
  const { credentials } = action;
  try {
    const loginsuccess = yield call(loginAuth.userAuth, credentials);
    if (
      loginsuccess.message === 'Please change password' ||
      loginsuccess.message === 'Password has been expired!!' ||
      loginsuccess.message === 'Please change your default password'
    ) {
      yield put(NavigationAction.navigationsuccess(`/changeFirstPassword/${credentials.identifier}`));
    } else if (loginsuccess.message) {
      message.error(loginsuccess.message);
    } else {
      yield put(LoginAction.userLoginAuthSuccess(loginsuccess));
    }
  } catch (error) {
    console.log(error);
  }
}

export function* userSignUpAuth(payload) {
  const signupSuccess = yield call(loginAuth.signUpAuth, payload.payload);
  if (signupSuccess.message) {
    message.error(signupSuccess.message);
  } else {
    yield put(LoginAction.userLoginAuthSuccess(signupSuccess));
    message.success('User created');
  }
}

export default function* watchGetPostSaga() {
  yield takeLatest(types.USERLOGIN_AUTH, userLoginAuth);
  yield takeLatest(types.USERSIGNUP_AUTH, userSignUpAuth);
}
